import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';

interface BankInfo {
  requestProcessInfo: React.ReactElement;
  iniProcessInfo: React.ReactElement;
  costsInfo?: React.ReactElement;
}

const bankInfos: { [key: string]: BankInfo } = {
  GENODEM1GLS: {
    iniProcessInfo: <GLSBankIniInfo />,
    requestProcessInfo: <GLSBankRequestInfo />,
    costsInfo: <GLSBankCostsInfo />,
  },
  TESTDE89XXX: {
    iniProcessInfo: <GLSBankIniInfo />,
    requestProcessInfo: <GLSBankRequestInfo />,
    costsInfo: <GLSBankCostsInfo />,
  },
};

const bankInfoByBic = (bic: string): BankInfo => {
  const info = bankInfos[bic];

  if (info) {
    return info;
  } else {
    return {
      iniProcessInfo: <DefaultBankIniInfo />,
      requestProcessInfo: <DefaultBankRequestInfo />,
      costsInfo: <DefaultBankCostInfo />,
    };
  }
};

function DefaultBankIniInfo(): ReactElement {
  const { t } = useTranslation('sepa');
  return <>{t('sepa:ini_process.generic.main')}</>;
}

function DefaultBankRequestInfo(): ReactElement {
  const { t } = useTranslation('sepa');
  return <>{t('sepa:request_process.generic.main')}</>;
}


function DefaultBankCostInfo(): ReactElement {
  const { t } = useTranslation('sepa');
  return (
    <>
      <p>{t('sepa:request_process.generic.costs')}</p>
      <p>
          {t('sepa:request_process.generic.link')}
      </p>
    </>
  );
}

// GLS Bank
function GLSBankIniInfo(): ReactElement {
  const { t } = useTranslation('sepa');
  return <>{t('ini_process.GENODEM1GLS.main')}</>;
}

function GLSBankRequestInfo(): ReactElement {
  const { t } = useTranslation('sepa');
  return <>{t('request_process.GENODEM1GLS.main')}</>;
}

function GLSBankCostsInfo(): ReactElement {
  const { t } = useTranslation('sepa');
  return (
    <>
      <p>{t('request_process.GENODEM1GLS.costs')}</p>
      <p>
        <a target="_blank" rel="noreferrer" href="https://www.gls.de/konten-karten/zahlungsverkehr/sepa-zahlungsverkehr/alles-zu-ebics/">
          {t('request_process.GENODEM1GLS.link')}
        </a>
      </p>
    </>
  );
}

export { bankInfoByBic };
